import { useContext, useMemo } from 'react';

import AppContext from './private/AppContext';

export default function useVersion(): readonly [string] {
  const context = useContext(AppContext);

  return useMemo(() => Object.freeze([context.database.runNumber] as const), [context.database.runNumber]);
}
